import { render } from "./SidebarItem.vue?vue&type=template&id=0b54b0b5&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__